import React, { useContext } from "react";
import { AppContext } from "../../context";
import { Button } from "@mantine/core";
import { createStyles } from "@mantine/emotion";

const useStyles = createStyles((theme) => ({
  button: {
    backgroundColor: "var(--button-primary-bg-color)",
    color: "var(--button-primary-color)",
    "&:hover": {
      backgroundColor: "var(--button-primary-hover-bg-color)",
      color: "var(--button-primary-hover-color)",
    },
  },
  discreetButton: {
    color: "var(--button-primary-bg-color)",
    padding: "0",
    "&:hover": {
      color: "var(--button-primary-bg-color)",
      backgroundColor: "var(--theme-subtle-color)",
    },
  },
}));

const User = () => {
  const { classes } = useStyles();
  const {
    state: { config, auth, language, userManager },
  } = useContext(AppContext);

  if (!userManager) {
    return <div>Använd en annan webläsare om du vill logga in</div>;
  }

  const variant = config?.discreetLoginButton ? "subtle" : "filled";

  const handleLogin = () => {
    userManager.clearStaleState();
    userManager.signinRedirect().catch((err) => console.log("Error!", err));
  };
  const handleLogout = () => {
    userManager.signoutRedirect().catch((err) => console.log("Error!", err));
  };

  if (auth) {
    return (
      <Button
        variant={variant}
        className={`${
          config?.discreetLoginButton ? classes.discreetButton : classes.button
        } user__login-button`}
        onClick={handleLogout}
        size={config?.discreetLoginButton ? "xs" : "sm"}
      >
        {language?.Logout || "logout"}
      </Button>
    );
  } else {
    return (
      <Button
        variant={variant}
        className={`${
          config?.discreetLoginButton ? classes.discreetButton : classes.button
        } user__login-button`}
        onClick={handleLogin}
        size={config?.discreetLoginButton ? "xs" : "sm"}
      >
        {language?.Login || "login"}
      </Button>
    );
  }
};

export default User;
